/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '../utils/UNSAFE_classNames';
import { globalImages } from '#/ImageVars.css';
import { sparkleStyles } from './themes/ListStyles.css';
import { useTheme } from '#/hooks/UNSAFE_useTheme';

const SPARKLE_STYLE_CLASS = 'oj-collection-sparkle';

/**
 * A sparkle component for smart suggestion indicator in ListView
 * @param sparkleHeight the height of sparkle
 */
export function Sparkle({ sparkleHeight }: { sparkleHeight: number }) {
  const { name } = useTheme();
  if (sparkleHeight <= 0) {
    return null;
  }

  const height = sparkleHeight + 'px';
  const sparkleClasses = classNames([sparkleStyles.base]);
  const containerClasses = classNames([
    sparkleStyles.container,
    SPARKLE_STYLE_CLASS,
    // TODO: this component should create separate theme definitions to only show the image in redwood
    name === 'redwood' && globalImages
  ]);

  return (
    <div key="sparkle" class={containerClasses}>
      <div class={sparkleClasses} style={{ height }}></div>
    </div>
  );
}
